import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import styles from './ConversationPanel.module.css';
import MessageContent from './MessageContent';
import type AssistantMessageModel from '../../../framework/models/AssistantMessage';
import classNames from 'classnames';

interface AssistantMesssageProps {
  message: AssistantMessageModel;
}

const SafeWrapper: React.FC<{
  message: AssistantMessageModel;
  children: React.ReactNode;
}> = ApplicationView(({ message, children }) => {
  const [show, setShow] = React.useState(false);

  if (message.safe || show) {
    return <>{children}</>;
  } else {
    return (
      <div className={styles.assistantMessageUnsafeContainer}>
        <div className={styles.assistantMessageUnsafe} aria-hidden>
          {children}
        </div>
        <div className={styles.assistantMessageUnsafeOverlay}>
          <div className={styles.assistantMessageUnsafeMessage}>
            This message may contain unsafe content{' '}
            <aha-button size='mini' onClick={() => setShow(true)}>
              Show anyway
            </aha-button>
          </div>
        </div>
      </div>
    );
  }
});

const AssistantMessage: React.FC<AssistantMesssageProps> = ({
  message,
}: AssistantMesssageProps) => {
  /*
  const artifactCandidate =
    message.content.length > 500 || message.content.split('\n').length > 4;

    <aha-button
          kind='icon'
          size='mini'
          onClick={() => model.convertToArtifact(message)}
        >
          <i className='fa-regular fa-file-lines' />
          <aha-tooltip style={{ '--Tooltip__tooltip--min-width': 0 }}>
            Convert to an artifact
          </aha-tooltip>
        </aha-button>
  */

  const buttons = (
    <div className={styles.assistantMessageButtons}>
      <aha-copy-button size='mini' text={message.content} />
    </div>
  );

  return (
    <div
      className={classNames(styles.assistantMessage, {
        [styles.assistantMessageWithContent]: message.content?.length > 0,
      })}
      data-message-id={message.id}
    >
      <SafeWrapper message={message}>
        {message.content && (
          <div>
            <MessageContent
              body={message.content}
              contentType={'text/markdown'}
            />
            {!message.active && message.content.length > 0 && buttons}
          </div>
        )}
      </SafeWrapper>
    </div>
  );
};

export default ApplicationView(AssistantMessage);
